import BigNumber from 'bignumber.js'
import { Farm } from 'state/types'
import { getAddress } from 'utils/addressHelpers'
import { getBalanceAmount } from 'utils/formatBalance'

const getTokenPricesFromFarm = (farms: Farm[]) => {
  return farms.reduce((prices, farm) => {
    const quoteTokenAddress = getAddress(farm.quoteToken.address).toLocaleLowerCase()
    const tokenAddress = getAddress(farm.token.address).toLocaleLowerCase()
    const lpTokenAddress = getAddress(farm.address).toLocaleLowerCase()
    /* eslint-disable no-param-reassign */
    if (!prices[quoteTokenAddress]) {
      prices[quoteTokenAddress] = new BigNumber(farm.quoteToken.usdcPrice).toNumber()
    }
    if (!prices[tokenAddress]) {
      prices[tokenAddress] = new BigNumber(farm.token.usdcPrice).toNumber()
    }

    if (farm.lpTotalSupply && farm.lpTotalInQuoteToken) {
      // Total value of base token in LP
      const valueOfBaseTokenInFarm = new BigNumber(farm.token.usdcPrice).times(farm.tokenAmountTotal)
      // Double it to get overall value in LP
      const overallValueOfAllTokensInFarm = valueOfBaseTokenInFarm.times(2)
      // Divide total value of all tokens, by the number of LP tokens
      const totalLpTokens = getBalanceAmount(new BigNumber(farm.lpTotalSupply))
      const lpTokenPrice = overallValueOfAllTokensInFarm.div(totalLpTokens)
      if (!prices[lpTokenAddress]) {
        prices[lpTokenAddress] = new BigNumber(lpTokenPrice).toNumber()
      }
    }

    /* eslint-enable no-param-reassign */
    return prices
  }, {})
}

export default getTokenPricesFromFarm
